import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import ClientDataNavUI from '../../../components/superUser/clientData/ClientDataNavUI'
import MCADataCollectionSF from '../../../components/superUser/clientData/MCADataCollectionSF'
import GSTDataCollectionSF from '../../../components/superUser/clientData/GSTDataCollectionSF'
import ITRDataCollectionSF from '../../../components/superUser/clientData/ITRDataCollectionSF'
import BankStatementCollectionSF from '../../../components/superUser/clientData/BankStatementCollectionSF'
import DocumentUploadSF from '../../../components/superUser/clientData/DocumentUploadSF'

const DataCollectionPage2UI = ({
  context, account, errorList, onRefreshClick,
  onCopyToClipboard, copyToClipboardText, onAccountUpdate,
  npFileList, mcaFileList, bsFileList, itrFileList, gstFileList, bankAccountList
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_doc_col' backLink='/su/accounts'
    headerText={account && account.accountName} centered={!account} account={account} page='clientData'
  >
    {
      !account &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      account &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Client Data Collection</b></span>
            </span>
          }
          right={<span />}
        />

        <ClientDataNavUI account={account} page='dataCollection' />

        <div className='g_muted'>
          <span className='g_muted g_m_left_100'>Account Id: {account.accountId}</span>
          <CopyToClipboard text={account.accountId}
            onCopy={onCopyToClipboard}>
            <span className='g_m_left_50 icon icon-clone g_cursor_pointer' />
          </CopyToClipboard>
          {
            copyToClipboardText === account.accountId &&
            <span className='g_m_left_50'>copied</span>
          }
        </div>

        <MCADataCollectionSF
          context={context}
          account={account}
          onRefreshClick={onRefreshClick}
          mcaFileList={mcaFileList}
        />

        <GSTDataCollectionSF
          context={context}
          account={account}
          onRefreshClick={onRefreshClick}
          gstFileList={gstFileList}
        />

        <ITRDataCollectionSF
          context={context}
          account={account}
          onRefreshClick={onRefreshClick}
          itrFileList={itrFileList}
        />

        <BankStatementCollectionSF
          context={context}
          account={account}
          onRefreshClick={onRefreshClick}
          bsFileList={bsFileList}
          npFileList={npFileList}
          onAccountUpdate={onAccountUpdate}
          bankAccountList={bankAccountList}
        />

        {/* <DocumentUploadSF
          context={context}
          account={account}
          onRefreshClick={onRefreshClick}
          npFileList={npFileList}
          onAccountUpdate={onAccountUpdate}
          onCopyToClipboard={onCopyToClipboard}
          copyToClipboardText={copyToClipboardText}
        /> */}
      </div>
    }
  </SuperUserAccountPageUI>

export default DataCollectionPage2UI
